'use strict';

angular.module('sellers')
.directive('horizontalSlider',['$rootScope', function ($rootScope) {
  return {
    restrict : "E"
    ,replace: true
    ,scope: false
    ,template : '<div class="ui small images horizontal-slider">'+
               '  <img class="ui bordered image thumb" ng-class="{active:property.activeImage == $index}" ng-src="{{image}}" ng-click="setMainImage(image, $index)" ng-repeat="image in property.images">'+
               '</div>'
    ,link : function (scope, element, attrs) {
    
      var x = document.getElementsByClassName("horizontal-slider");

      scope.setMainImage = function(src, index){
        scope.property.mainImg = src;
        scope.property.activeImage = index;
      };

      scope.setWidth = function () {
        var w = scope.property.images.length * 100;
        element.css({'width': w+'px'});
      };

      scope.$watch('property.images', function(newValue) {
          if (newValue !== undefined) {
              scope.setWidth();
          }
      });

      // If we detect a touch screen
      if($rootScope.browser.touchSupport){
        var left = 0;
        var hammer    = new Hammer.Manager(x[0]);
        var swipe     = new Hammer.Swipe();

        hammer.add(swipe);

        hammer.on('release', function(e) { 
          var pattern = new RegExp('translate3d\\((-?[0-9]*)px, 0, 0\\)'),
              pattern2 = new RegExp('(-?[0-9]*)px');
          var transformMatches = pattern.exec(element.css('-webkit-transform')),
              widthMatches = pattern2.exec(element.css('width'));
          left = Math.round(transformMatches[1]);
          var width = widthMatches[1];
          if(left < (320 - width)) left = 320 - width;
          if(left > 0) left = 0;

          element.addClass('slider-bounce');
          element.css({
            '-webkit-transform': 'translate3d(' + left + 'px, 0, 0)'
          });
        });
        
        hammer.on('swipe', function(e) {
          element.css({
            '-webkit-transform': 'translate3d(' + (left + Math.round(e.deltaX)) + 'px, 0, 0)'
          });
          if (element.hasClass('slider-bounce')) {
            element.removeClass('slider-bounce');
          }
        });
      }
    }
  }
}]);
